import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { checkPaytmStatus } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import {
  redirectToPaymentSuccessPage,
  redirectToPaymentFailurePage,
  redirectToOrderProcessingPage,
} from '../../../common/utilities/utils';
import { PAYMENT_TENDER_TYPES, ROUTE_URL } from '../../../common/constants/SharedConstants';
import OrderConfirmScreen from 'organisms/PaymentProcess/Presentation/orderConfirmStatus';

export const dispatchCheckPaytmStatus = (dispatch, tenantId, transactionId, orderReducerResponse) => {
  const { customer } = orderReducerResponse?.order;
  const requestData = {
    tenantId,
    transactionId,
    customerId: customer?.id,
  };
  dispatch(checkPaytmStatus(requestData));
};

export const PaymentStatusCheck = props => {
  const dispatch = useDispatch();
  const { tenantReducer, paymentsReducer, orderReducer } = useSelector(data => {
    return data;
  });
  const [paymentStatusChecked, setPaymentStatusChecked] = useState(false);

  useEffect(() => {
    if (window?.location?.pathname?.includes(ROUTE_URL?.DGFT_PAYMENT_STATUS_CHECK)) {
      redirectToOrderProcessingPage(props);
    } else if (localStorage.getItem('postPaymentType') === PAYMENT_TENDER_TYPES.PAYTM) {
      if (tenantReducer?.tenantId && orderReducer?.response && paymentsReducer?.response?.transactionId) {
        dispatchCheckPaytmStatus(
          dispatch,
          tenantReducer?.tenantId,
          paymentsReducer?.response?.transactionId,
          orderReducer?.response,
        );
        setPaymentStatusChecked(true);
      }
    } else {
      redirectToPaymentSuccessPage(props);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantReducer?.tenantId, orderReducer?.response, paymentsReducer?.response]);

  useEffect(() => {
    if (localStorage.getItem('postPaymentType') === PAYMENT_TENDER_TYPES.PAYTM) {
      if (paymentsReducer?.paytmStatusData && paymentStatusChecked) {
        setPaymentStatusChecked(false);
        if (paymentsReducer?.paytmStatusData?.status === 'success') {
          redirectToPaymentSuccessPage(props);
        } else {
          redirectToPaymentFailurePage(props);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentStatusChecked, paymentsReducer?.paytmStatusData?.status]);

  return (
    <div className='PostPaymentProcessComponent'>
      <OrderConfirmScreen showLoader='false' />
    </div>
  );
};
